import { useState } from "react";
import { useConsents } from "../../hooks/useConsents";

// يمنع فتح الكاميرا قبل موافقة بيومترية صريحة، ثم يُكمل الإجراء المطلوب تلقائياً.
export const useBiometricGate = () => {
  const { state, accept, reload } = useConsents();
  const [pending, setPending] = useState(null);

  const guard = (action) => {
    if (state && !state.biometric) {
      setPending(() => action);
      return;
    }
    action();
  };

  const onAccept = async () => {
    await accept(["biometric"]);
    const action = pending;
    setPending(null);
    await reload();
    if (action) action();
  };

  return {
    granted: Boolean(state?.biometric),
    guard,
    gate: { open: Boolean(pending), onAccept, onClose: () => setPending(null) },
  };
};
